<template>
  <div class="page">
    <div class="card pb20">
      <el-row :gutter="20" class="lg36">
        <el-col :xs="24" :sm="12" :md="10" :lg="6" :xl="4">
          <img
            class="cover-img opacity50"
            :src="srcList[0] + '?x-oss-process=image/auto-orient,1/resize,m_lfit,w_250/quality,q_100/format,jpg'"
            alt=""
          />
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
          <div class="info-item">
            <span class="f14 lightColor wrap">{{ $t('common.boutiqueId') }}: </span>
            <span class="f16 bold wrap">{{ detail.productCode }}</span>
          </div>
          <div class="info-item">
            <span class="f14 lightColor wrap">{{ $t('common.brand') }}: </span>
            <span class="f16 bold wrap">{{ detail.brandName }}</span>
          </div>
          <div class="info-item">
            <span class="f14 lightColor wrap">{{ $t('common.productName') }}: </span>
            <span class="f16 bold wrap">{{ detail.productName }}</span>
          </div>
          <div class="info-item">
            <span class="f14 lightColor wrap">{{ $t('common.category') }}: </span>
            <span class="f16 bold wrap">{{ detail.categoryL1 ? detail.categoryL1 + '>' + detail.categoryL2 + '>' + detail.categoryL3 : '' }}</span>
          </div>
          <div class="info-item">
            <span class="f14 lightColor wrap">{{ $t('common.designerId') }}: </span>
            <span class="f16 bold wrap keep-space">{{ detail.designerId }}</span>
          </div>
          <div class="info-item">
            <span class="f14 lightColor wrap">{{ $t('common.color') }}: </span>
            <span class="f16 bold wrap keep-space">{{ detail.colorCode }}</span>
          </div>
          <div class="info-item">
            <span class="f14 lightColor wrap">{{ $t('common.season') }}{{ showIsCo ? `(${$t('common.isCo')})` : '' }}: </span>
            <span class="f16 bold wrap">{{ detail.seasonCode2 }}{{ detail.coFlag === 1 ? '(CO)' : '' }}</span>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
          <div class="info-item" v-if="isPreSale != 2">
            <span class="f14 lightColor wrap">{{ $t('product.isPresaleProduct') }}: </span>
            <span class="f16 bold wrap" v-if="detail.productType == 1">{{ $t('product.normalSales') }}</span>
            <span class="f16 bold wrap" v-if="detail.productType == 2">{{ $t('product.preSale') }}</span>
            <span class="f16 bold wrap" v-if="detail.productType == 4">{{ $t('product.reservation') }}</span>
          </div>
          <div class="info-item" v-if="detail.productType == 2">
            <span class="f14 lightColor wrap">{{ $t('product.expectedArrivalTime') }}: </span>
            <span class="f16 bold wrap"
              >{{ detail.arrivalTimeMin | dateFormat('yyyy-MM-dd') }} ~ {{ detail.arrivalTimeMax | dateFormat('yyyy-MM-dd') }}</span
            >
          </div>
          <div class="info-item" v-if="detail.productType == 4">
            <span class="f14 lightColor wrap">{{ $t('product.orderDays') }}: </span>
            <span class="f16 bold wrap">{{ countDays(detail.arrivalTimeMin) }} ~ {{ countDays(detail.arrivalTimeMax) }}</span>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="card pt5">
      <el-tabs v-model="activeName">
        <el-tab-pane :label="$t('product.price&Inventory')" name="first"></el-tab-pane>
        <el-tab-pane :label="$t('product.info')" name="second"></el-tab-pane>
        <el-tab-pane :label="$t('product.images')" name="third"></el-tab-pane>
        <el-tab-pane :label="$t('product.syncRecord')" name="fourth"></el-tab-pane>
      </el-tabs>
    </div>

    <el-table class="spacing-table" :data="detail.productSkuVOS" v-if="activeName === 'first'">
      <el-table-column prop="skuCode" :label="$t('product.skuCode')"></el-table-column>
      <el-table-column prop="sizeStandard" :label="$t('product.sizeStandard')"></el-table-column>
      <el-table-column prop="size" :label="$t('common.size')"></el-table-column>
      <el-table-column v-if="isShowDefectLevel" prop="skuDefectLevel" :label="$t('product.defectLevel')"></el-table-column>
      <el-table-column prop="retailPrice" :label="$t('common.retailPrice')"></el-table-column>
      <el-table-column v-if="supplyPriceMethod === 1" prop="supplyPrice" :label="$t('common.supplyPrice')"></el-table-column>
      <el-table-column v-if="supplyPriceMethod === 2" prop="costPrice" :label="$t('product.costPrice')"></el-table-column>
      <el-table-column prop="stock" :label="$t('common.stock')"></el-table-column>
    </el-table>

    <div class="card pb20" v-if="activeName === 'second'">
      <base-info label-width="100px">
        <base-info-item col="4" :label="$t('common.productName')">{{ detail.productName }}</base-info-item>
        <base-info-item col="4" :label="$t('common.color')">{{ detail.colorDescription }}</base-info-item>
        <base-info-item col="4" :label="$t('product.composition')">{{ detail.composition }}</base-info-item>
        <base-info-item col="4" :label="$t('product.producingArea')">{{ detail.madeInStandardName }}</base-info-item>
        <base-info-item col="4" :label="$t('product.productDesc')">{{ detail.productDescription }}</base-info-item>
        <base-info-item col="4" :label="$t('product.sizeDesc')">{{ detail.sizeDescription }}</base-info-item>
      </base-info>
    </div>

    <div class="card pb20" v-if="activeName === 'third'">
      <div class="img-list">
        <el-image
          class="img-item"
          v-for="(url, index) in srcList"
          :key="index"
          :src="url + '?x-oss-process=image/auto-orient,1/resize,m_lfit,w_150/quality,q_100/format,jpg'"
          :preview-src-list="srcList"
        ></el-image>
      </div>
    </div>

    <template v-if="activeName === 'fourth'">
      <query-form label-width="100px">
        <template v-slot:formitem>
          <query-form-item :label="$t('common.dateRange')">
            <el-date-picker
              v-model="daterange"
              type="daterange"
              range-separator="~"
              :picker-options="pickerOptions"
              value-format="timestamp"
              :default-time="['00:00:00', '23:59:59']"
              style="width: 100%"
            >
            </el-date-picker>
          </query-form-item>
          <query-form-item :label="$t('product.updateType')">
            <el-select v-model="queryForm.changedType" clearable style="width: 100%">
              <el-option v-for="item in updateTypeList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </query-form-item>
          <query-form-item :label="$t('product.updateField')">
            <el-select v-model="queryForm.changeField" clearable style="width: 100%">
              <el-option v-for="item in fieldList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </query-form-item>
        </template>
        <template>
          <el-button class="mb20" type="primary" @click="search">{{ $t('common.search') }}</el-button>
          <el-button class="mb20" type="info" @click="reset">{{ $t('common.reset') }}</el-button>
        </template>
      </query-form>
      <el-table :data="tableData2">
        <el-table-column prop="createdAt" :label="$t('product.at')"></el-table-column>
        <el-table-column prop="eventType" :label="$t('product.updateType')"></el-table-column>
        <el-table-column prop="skuCode" :label="$t('product.skuCode')"></el-table-column>
        <el-table-column prop="size" :label="$t('common.size')"></el-table-column>
        <el-table-column prop="changeField" :label="$t('product.updateField')"></el-table-column>
        <el-table-column prop="changedContent" :label="$t('product.content')"></el-table-column>
        <el-table-column :label="$t('common.action')">
          <template slot-scope="scope">
            <el-button type="primary" v-if="scope.row.requestId && messageBtn" @click="getSyncRecordMessage(scope.row.requestId)">{{
              $t('product.viewMessage')
            }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="tr"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.pageNo"
        :page-sizes="[10, 25, 50, 100]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </template>

    <el-dialog title="Product Trace" v-loading="loading" :visible.sync="dialogVisible">
      <p>{{ alijson }}</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="dialogVisible = false">{{ $t('common.ok') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { differenceInCalendarDays } from 'date-fns';
import {
  getProductDetail, getSyncRecordByBoutiqueProductId, getSyncRecordMessage, getChangeFieldList, getUpdateTypeList,getMadeInStandardList
} from '../../api/product';
import i18n from '@/plugins/i18n';

function checkPermission(list, code) {
  for (let i = 0; i < list.length; i++) {
    const menu = list[i];
    if (menu.code.endsWith('product_manager')) {
      for (let j = 0; j < menu.children.length; j++) {
        const sub = menu.children[j];
        if (sub.code === 'all_product') {
          for (let k = 0; k < sub.children.length; k++) {
            const element = sub.children[k];
            if (element.code === code) {
              return true;
            }
          }
        }
      }
    }
  }
  return false;
}

export default {
  name: 'ProductDetail',
  data() {
    return {
      detail: {},
      srcList: [],
      activeName: 'first',
      daterange: [],
      fieldList: [],
      updateTypeList: [],
      queryForm: {
        changedType: null,
        changeField: null,
        pageNo: 1,
        pageSize: 25,
      },
      dialogVisible: false,
      tableData2: [],
      total: 0,
      alijson: '',
      loading: false,
      pickerOptions: {
        disabledDate(date) {
          if (differenceInCalendarDays(new Date(), new Date(date)) < 0) {
            return true;
          }
          if (differenceInCalendarDays(new Date(), new Date(date)) >= 30) {
            return true;
          }
          return false;
        },
      },
      madeInStandardList: []
    };
  },
  computed: mapState({
    showIsCo: (state) => state.userinfo.coFlag === 1,
    supplyPriceMethod: (state) => state.userinfo.supplyPriceMethod,
    provideRetailPrice: (state) => state.userinfo.provideRetailPrice,
    isPreSale: (state) => state.userinfo.isPreSale,
    messageBtn: (state) => checkPermission(state.menuList, 'message'),
    isShowDefectLevel: (state) => state.userinfo.isShowDefectLevel,
  }),
  async created() {
    await this.getMadeInStandardList()
    this.getDetail();
    getChangeFieldList().then((res) => {
      this.fieldList = res.data;
    });
    getUpdateTypeList().then((res) => {
      this.updateTypeList = res.data;
    });
  },
  methods: {
    async getMadeInStandardList() {
      var res = await getMadeInStandardList();
      this.madeInStandardList = (res.data || []).map(item => {
        return {
          ...item,
          label: i18n.locale == "en" ? item.englishName : item.name
        }
      });
    },
    getDetail() {
      getProductDetail({
        boutiqueProductId: this.$route.params.id,
      }).then((res) => {
        if (res.success && res.data) {
          this.srcList = (res.data.imgVOS || []).map((item) => item.img);
          this.detail = {
            ...res.data,
            madeInStandardName: ""
          };
          if(res.data.standardMadeInId) {
            var madeInStandard = this.madeInStandardList.find(item => item.standardMadeInId == res.data.standardMadeInId);
            this.detail.madeInStandardName = i18n.locale == "en" ? madeInStandard.englishName : madeInStandard.name
          }
          this.getRecord();
        } else {
          this.$message.error(res.message || this.$t('error.systemerror'));
        }
      });
    },
    search() {
      this.queryForm.pageNo = 1;
      this.getRecord();
    },
    reset() {
      this.queryForm.changedType = null;
      this.queryForm.changeField = null;
      this.queryForm.pageNo = 1;
      this.daterange = [];
      this.getRecord();
    },
    getRecord() {
      getSyncRecordByBoutiqueProductId({
        boutiqueProductId: this.detail.boutiqueProductId,
        changedType: this.queryForm.changedType,
        changeField: this.queryForm.changeField,
        startTime: this.daterange ? this.daterange[0] : null,
        endTime: this.daterange ? this.daterange[1] : null,
        pageNo: this.queryForm.pageNo,
        pageSize: this.queryForm.pageSize,
      }).then((res) => {
        if (res.success && res.data) {
          this.tableData2 = res.data.list;
          this.total = res.data.total;
        } else {
          this.$message.error(res.message || this.$t('error.systemerror'));
        }
      });
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getRecord();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getRecord();
    },
    getSyncRecordMessage(requestId) {
      this.dialogVisible = true;
      this.loading = true;
      getSyncRecordMessage({
        requestId,
      }).then((res) => {
        this.loading = false;
        this.alijson = res.data;
      });
    },
    countDays(time) {
      return differenceInCalendarDays(new Date(time), new Date());
    },
  },
};
</script>

<style scoped lang="scss">
.cover-img {
  width: 250px;
}
</style>
